import { render, staticRenderFns } from "./upsertElementModal.vue?vue&type=template&id=15df2b1f&scoped=true&"
import script from "./upsertElementModal.vue?vue&type=script&lang=ts&"
export * from "./upsertElementModal.vue?vue&type=script&lang=ts&"
import style0 from "./upsertElementModal.vue?vue&type=style&index=0&id=15df2b1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15df2b1f",
  null
  
)

export default component.exports